import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'
const base = 'company-payouts'

AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('../companies/Commissions.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItem({
  id: `${base}`,
  order: 30,
  header: $vm => $vm.$t(`general.menu_main`),
  text: $vm => $vm.$t(`company.commissions.title`),
  route: {
    name: `${base}`,
  },
  icon: 'icon-percent',
  permission: $vm => {
    return $vm.$account && $vm.$account.company && !$vm.$allows('administer')
  },
})

messageGroups.push(base)
